<template>
  <div class="card-gif block-card card-border ">
    <v-expansion-panel 
      :value="panel" 
      expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header >
          <div class="block-card-title handle" >
            <div class="title-icon">
              <span class="botter-gif-icon white--text text-lg-2" />
            </div>

            <h4>
              GIF 
              <v-icon 
                v-if = "errorsCount && errorsCount.errorsCount" 
                color = "error" 
                style = "margin-left: 4px;">error</v-icon>
              <span class="text--error" v-if="!validData">(Invalid Card Data)</span>
            </h4>
          </div>
        </template>
        <form-validation v-model = "errorsCount">
          <div class="block-card-body" v-if="validData">

            <label >URL</label>
            <vTextareaAutocomplete
              v-model="data.url"
              :validation-rules="autocompleteGifUrlValidationRules"
              type="textfield" />


              <label >Upload Your GIF</label>
              <image-input 
                :url="data.url" 
                drag-placeholder = "Drag and Drop Your GIF here" 
                @onImageUpload="updateImageUrl"/>



          </div>
        </form-validation>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from '../../../../utils/common'
import FormValidation from '../FormValidation'
import imageInput from './common-inner-blocks/image-uploader-dropzone'
export default {
  name: 'CardGif',
  components: {
    imageInput,
    FormValidation
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: () => {
        return 0
      }
    },
    blocksList: {
      type: Array,
      default: () => {
        return []
      }
    },
    validData: {
      type: Boolean,
      default: ()=> {
        return false
      }
    }
  },
  data() {
    return {
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      valid: true,
      panel: 1,
      common,
      autocompleteGifTitleValidationRules: [v => !!v || 'Title is Required'],
      autocompleteGifDescValidationRules: [
        v => !!v || 'Description is Required'
      ],
      autocompleteGifUrlValidationRules: [v => !!v || 'Url is Required']
    }
  },
  computed: {},
  watch: {
    errorsCount(val) {
      this.$emit('input', { errorsCount: val.errorsCount })
      this.data.errorsCount = val.errorsCount
    }
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true
      }, 1000)
    }
  },
  methods: {
    updateImageUrl(url) {
      this.data.url = url
    }
  }
}
</script>

<style scoped>
</style>
